import React from 'react';
import { observer } from 'mobx-react-lite';
import { RouteConfig } from 'routes/index';
import { enrollmentRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useRootStore } from 'store/rootStore';
import { Switch } from 'react-router-dom';
import RoleBasedRoute from 'routes/RoleBasedRoute';
import ManageAddEmployeesPage from 'pages/enrollment/manage-add-employess/ManageAddEmployeesPage';
import CensusUploadPage from 'pages/enrollment/manage-add-employess/CensusUploadPage';
import CensusReviewPage from 'pages/enrollment/manage-add-employess/CensusReviewPage';

const routes: RouteConfig[] = [
  {
    path: '/manage-add-employees/census-upload/:groupId/:periodId',
    component: CensusUploadPage,
    roleCheck: enrollmentRights,
  },
  {
    path: '/manage-add-employees/census-review/:groupId/:periodId',
    component: CensusReviewPage,
    roleCheck: enrollmentRights,
  },
  {
    path: '/manage-add-employees/:groupId/:periodId',
    component: ManageAddEmployeesPage,
    roleCheck: enrollmentRights,
  },
];

const LocalRouter: React.FC = observer(() => {
  const {
    userStore: { userRoles },
  } = useRootStore();

  const convertedUserRoles = userRoles.slice();
  return (
    <Switch>
      {routes.map((route) => (
        <RoleBasedRoute exact key={route.path} userRoles={convertedUserRoles} {...route} />
      ))}
    </Switch>
  );
});

export const ManageAddEmployeesFlow: React.FC = () => {
  return <LocalRouter />;
};
